/**
 * ExFleet Sticky Add-to-Cart bar
 *
 * Watches the main Add-to-Cart wrapper ([data-exfleet-main-atc]). When it
 * scrolls above the viewport, the sticky bar appears; when it re-enters, the
 * bar hides. Clicking the bar's "Add to cart" button triggers the main form's
 * submit so we inherit all existing cart / variant / quantity logic.
 */
(function () {
  'use strict';

  function init() {
    var stickyBars = document.querySelectorAll('[data-exfleet-sticky-cart]');
    if (!stickyBars.length) return;

    var mainAtc = document.querySelector('[data-exfleet-main-atc]');
    if (!mainAtc) return;

    // IntersectionObserver shows the bar when the main ATC is OUT of viewport.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting;
            stickyBars.forEach(function (bar) {
              bar.classList.toggle('is-visible', show);
              bar.setAttribute('aria-hidden', show ? 'false' : 'true');
            });
          });
        },
        { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
      );
      observer.observe(mainAtc);
    }

    // When sticky button is clicked, delegate to the main product form submit.
    stickyBars.forEach(function (bar) {
      var submitBtn = bar.querySelector('[data-exfleet-sticky-submit]');
      if (!submitBtn) return;

      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = mainAtc.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        // Scroll main ATC into view first so user sees the result of their action.
        mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Submit the main form (will hit theme's own variant/AJAX handling).
        var submit = form.querySelector('[type="submit"], [name="add"]');
        if (submit) {
          submit.click();
        } else {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
    });

    // Keep the sticky price in sync with variant switching.
    // Theme's section-main-product JS dispatches `variantChange` on the
    // product-component element.
    var priceTargets = document.querySelectorAll('[data-exfleet-sticky-price]');
    if (!priceTargets.length) return;

    var productComponent = document.querySelector('product-component');
    if (!productComponent) return;

    productComponent.addEventListener('variantChange', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) return;
      var formatted = formatMoney(variant.price);
      priceTargets.forEach(function (el) {
        el.textContent = formatted;
      });
    });
  }

  /**
   * Minimal money formatter — uses Shopify's `Shopify.formatMoney` if present,
   * otherwise falls back to a plain locale-formatted string.
   */
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
